import { useLocation, useNavigate } from "react-router-dom";
import AdminManageReason from './AdminManageReason'
import AdminMangeUsers from './AdminManageUsers'

const ApplicationAdmin = () => {
     const location = useLocation();
     if (location.pathname === "/admin/manage-users") {
      return <AdminMangeUsers />;
    } else if (location.pathname === "/admin/manage-reason-codes") {
      return <AdminManageReason />;
    }
}

export default ApplicationAdmin;